
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.75 24a.755.755 0 01-.417-.128.27.27 0 01-.033-.022L6.5 15H6v7.5h.75a.75.75 0 010 1.5h-6a.75.75 0 010-1.5h.75V15H.75a.75.75 0 01-.75-.75v-6a.75.75 0 01.75-.75h6a.743.743 0 01.253.045.76.76 0 01.19.1L19 16.5h4.25a.75.75 0 010 1.5h-.75v4.5h.75a.75.75 0 010 1.5h-4.5zM21 22.5V18h-1.5v4.5H21zm-16.5 0V15H3v7.5h1.5zm13.5-.75v-4.125L16.5 16.5l1.5 5.25zm-3-2.25v-4.125l-1.5-1.125L15 19.5zm-3-2.25v-4.125L10.5 12l1.5 5.25zM9 15v-4.125L7.5 9.75 9 15zm-3-1.5V9H4.5v4.5H6zm-3 0V9H1.5v4.5H3zM14.25 9.751a.72.72 0 01-.239-.041.785.785 0 01-.323-.215.293.293 0 01-.039-.044.97.97 0 01-.086-.151.624.624 0 01-.017-.046.592.592 0 01-.027-.091l-.009-.055a1.355 1.355 0 01-.008-.07L13.5 9V4.617l-2.54 1.975a.751.751 0 01-1.052-.132.75.75 0 01.131-1.052l6.75-5.25a.739.739 0 01.203-.111l.036-.012A.738.738 0 0117.25 0h6a.75.75 0 010 1.5H21V6h2.25a.75.75 0 010 1.5H17.5l-2.8 2.101a.725.725 0 01-.252.121.8.8 0 01-.198.029zM15 7.5l1.5-1.125V2.283L15 3.45V7.5zM19.5 6V1.5H18V6h1.5z"}})])
          )
        }
      }
    